
export default {
  name: 'AssessComment',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataMap: [
        '自动评分',
        '功能免费',
        '完善的数据分析',
        '快速创建',
        '支持防作弊',
        '题目自动评分',
        '超30万模版',
        '全部测评免费',
      ],
    }
  },
}
